export default {
	async importSymbol(name) {
		if (name) {
			return (await import(`@/assets/icons/brands/${name}-brands.svg`)).default.content;
		}

		return (await import('@/assets/icons/link.svg')).default.content;
	},
};
